<template>
  <div class="MdTxt" :class="textClass" :style="textStyle">
    <p v-if="data.text" v-html="normalizedText"></p>
    <p v-else-if="data.contents">
      <span v-for="(sp,index) in data.contents" :key="uid+'-span-'+index"
        :class="spanClass(sp)" :style="spanStyle(sp)">
        {{sp.text}}
      </span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'lineFlexTextElement',
  props: {
    data: {
      type: Object,
    },
    uid: String,
  },
  methods: {
    spanClass(sp) {
      const cl = {
        ExWR: sp.weight === 'regular',
        ExWB: sp.weight === 'bold',
        ExXXs: sp.size === 'xxs',
        ExXs: sp.size === 'xs',
        ExSm: sp.size === 'sm',
        ExMd: sp.size === 'md',
        ExLg: sp.size === 'lg',
        ExXl: sp.size === 'xl',
        ExXXl: sp.size === 'xxl',
        Ex3Xl: sp.size === '3xl',
        Ex4Xl: sp.size === '4xl',
        Ex5Xl: sp.size === '5xl',
      };
      return cl;
    },
    spanStyle(sp) {
      const style = {};
      if (sp.color) style.color = sp.color;
      if (sp.decoration) style.textDecoration = sp.decoration;
      if (sp.style) style.textStyle = sp.style;
      return style;
    },
  },
  computed: {
    textClass() {
      const cl = {
        ExAlgC: this.data.align === 'center',
        ExAlgE: this.data.align === 'end',
        ExWrap: this.data.wrap,
        ExWL: this.data.weight === 'light',
        ExWR: this.data.weight === 'regular',
        ExWB: this.data.weight === 'bold',
        ExXXs: this.data.size === 'xxs',
        ExXs: this.data.size === 'xs',
        ExSm: this.data.size === 'sm',
        ExMd: this.data.size === 'md',
        ExLg: this.data.size === 'lg',
        ExXl: this.data.size === 'xl',
        ExXXl: this.data.size === 'xxl',
        Ex3Xl: this.data.size === '3xl',
        Ex4Xl: this.data.size === '4xl',
        Ex5Xl: this.data.size === '5xl',
        fl0: this.data.flex === 0,
        fl1: this.data.flex === 1,
        fl2: this.data.flex === 2,
        fl3: this.data.flex === 3,
        grvC: this.data.gravity === 'center',
        grvB: this.data.gravity === 'bottom',
        ExAbs: this.data.position === 'absolute',
        ExMgnTXs: this.data.margin === 'xs',
        ExMgnTSm: this.data.margin === 'sm',
        ExMgnTMd: this.data.margin === 'md',
        ExMgnTLg: this.data.margin === 'lg',
        ExMgnTXl: this.data.margin === 'xl',
        ExMgnTXXl: this.data.margin === 'xxl',
      };
        // Todo add margin handle
      return cl;
    },
    textStyle() {
      const style = {};
      if (this.data) {
        if (this.data.color) {
          style.color = this.data.color;
        }
        if (this.data.offsetTop) style.top = this.data.offsetTop;
        if (this.data.offsetBottom) style.bottom = this.data.offsetBottom;
        if (this.data.offsetStart) style.left = this.data.offsetStart;
        if (this.data.offsetEnd) style.right = this.data.offsetEnd;
        if (this.data.decoration) style.textDecoration = this.data.decoration;
        if (this.data.style) style.textStyle = this.data.style;
      }
      return style;
    },
    normalizedText() {
      if (this.data.text) {
        const text = this.data.text || '';
        if (text) {
          const finalText = text.replace(/\n/g, '<br>');
          return finalText;
        }
        return text;
      }
      return '';
    },
  },
};
</script>
